type labeled = { label: string };
type named = { name: string };

export const stringCompare = (a: string, b: string) => a.localeCompare(b);
export const labelCompare = (a: labeled, b: labeled) => stringCompare(a.label, b.label);
export const nameCompare = (a: named, b: named) => stringCompare(a.name, b.name);
